import { motion } from "framer-motion";

const stats = [
  { value: "100%", label: "Background-Checked & Trained", sub: "Every crew member, every shift", testid: "stats-fill-rate" },
  { value: "< 3 hrs", label: "Emergency Fill Response", sub: "Backup crew dispatch window", testid: "stats-deploy-time" },
  { value: "24/7", label: "Operations Desk", sub: "A human answers — 0430 941 010", testid: "stats-events-count" },
  { value: "45 min", label: "Early Arrival Standard", sub: "Crew briefed & badged before doors", testid: "stats-insurance" },
];

export default function StatsBand() {
  return (
    <section className="border-y border-white/10 bg-[#0F111A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={s.testid}
            >
              <p className="font-mono-tactical text-3xl sm:text-4xl font-bold text-sky-500">
                {s.value}
              </p>
              <p className="mt-2 font-semibold text-white">{s.label}</p>
              <p className="text-sm text-slate-400">{s.sub}</p>
            </motion.div>
          ))}
        </div>
        <p className="mt-10 text-center font-mono-tactical text-[11px] uppercase tracking-[0.25em] text-slate-500">
          Built for tour promoters, stadium ops, city festivals & brand activations
        </p>
      </div>
    </section>
  );
}
